(function () {
  'use strict';

  /* Directives */
  angular.module('wsLrs.directives').
  /* expects either mbox and name or userId and name; and expects isGroup (which is treated as a function
   to keep the value a boolean and not a string)
   Size is not used right now as an attribute because the css is always going to display at 48px */
  directive('wsXapiAppsConnect', ['$http', '$timeout', 'Api', 'User', 'Utils', function ($http, $timeout, Api, User, Utils) {
    return {
      restrict: 'AE',
      scope: {},
      templateUrl: 'modules/common/directives/xapi-apps-connect/xapi-apps-connect.html',
      link: function link(scope) {
        scope.startXapiAppsConnect = function () {
          var session = User.get();
          var providerName = "xAPI Apps";
          var launchUrl = "https://signup.xapiapps.com/ws-entry.php";
          var startUrl = Utils.appendParams(Api.url("/integration/start"), {
            name: providerName
          });
          $http.post(startUrl).then(function success(response) {
            scope.key = response.data.key;
            scope.secret = response.data.secret;
            scope.orgId = session.organization.id;
            scope.orgName = session.organization.name;
            scope.userName = session.user.name;
            scope.userEmail = session.user.email;
            $timeout(function () {
              $("#xapiAppsLaunchForm").attr('action', launchUrl).submit();
            });
          }, function error() {});
        };
      }
    };
  }]);
})();
